module.exports = __webpack_public_path__ + "img/fair.58baa585.svg";